module.exports = __webpack_public_path__ + "static/img/solution_mainten.06580064.png";